import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import Button from '@atlaskit/button/custom-theme-button';
import Tooltip from '@atlaskit/tooltip';
import { useTheme } from '../../theme';
import { getIconButtonTheme } from './styles';
export var IconButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var icon = props.icon,
      testId = props.testId,
      tooltip = props.tooltip,
      buttonProps = _objectWithoutProperties(props, ["icon", "testId", "tooltip"]);

  var theme = useTheme();
  var button = /*#__PURE__*/React.createElement(Button, _extends({
    appearance: "primary",
    testId: testId,
    iconBefore: icon,
    ref: ref,
    theme: getIconButtonTheme(theme)
  }, buttonProps));

  if (tooltip) {
    return /*#__PURE__*/React.createElement(Tooltip, {
      content: tooltip,
      hideTooltipOnClick: true
    }, button);
  }

  return button;
});